import ajax from "@/lib/ajax"

// 读取所有化验指标
export async function GetLaboratoryIndicatorsList(payload:any){
	let res = await ajax.get("/api/services/app/LaboratoryCategories/GetLaboratoryIndicatorsList",{params:payload})
	return res.data.result
}

// 读取所有指标绑定
export async function GetBindingLaboratoryIndicatorsList(payload:any){
	let res = await ajax.get("/api/services/app/LaboratoryCategories/GetBindingLaboratoryIndicatorsList",{params:payload})
	return res.data.result
}

// 读取所有未绑定指标（必须模糊查询）
export async function GetAllIndicator(payload:any){
	let res = await ajax.get("/api/services/app/LaboratoryCategories/GetAllIndicator",{params:payload})
	return res.data.result
}

// 绑定指标保存
export async function SaveBindingLaboratoryIndicator(payload: any){
	let res = await ajax.post('/api/services/app/LaboratoryCategories/SaveBindingLaboratoryIndicator', payload)
	return res.data.result
}
// 绑定指标批量保存
export async function BatchSaveBindingLaboratoryIndicator(payload: any){
	let res = await ajax.post('/api/services/app/LaboratoryCategories/BatchSaveBindingLaboratoryIndicator', payload)
	return res.data.result
}

// 读取化验大类绑定
export async function GetBindingLaboratoryCategoriesList(payload:any){
	let res = await ajax.get("/api/services/app/LaboratoryCategories/GetBindingLaboratoryCategoriesList",{params:payload})
	return res.data.result
}

// 读取所有化验大类
export async function GetLaboratoryCategoriesList(payload:any){
	let res = await ajax.get("/api/services/app/LaboratoryCategories/GetLaboratoryCategoriesList",{params:payload})
	return res.data.result
}

// 绑定大类批量保存
export async function BatchSaveBindingLaboratoryCategorie(payload: any){
	let res = await ajax.post('/api/services/app/LaboratoryCategories/BatchSaveBindingLaboratoryCategorie', payload)
	return res.data.result
}

// 删除化验大类
export async function DeleteLaboratoryCategories(payload: any){
	let res = await ajax.delete('/api/services/app/LaboratoryCategories/DeleteLaboratoryCategories', {params:payload})
	return res.data.result
}
// 保存化验大类
export async function SaveLaboratoryCategories(payload: any){
	let res = await ajax.post('/api/services/app/LaboratoryCategories/SaveLaboratoryCategories', payload)
	return res.data.result
}
// 保存标准指标
export async function SaveLaboratoryIndicators(payload: any){
	let res = await ajax.post('/api/services/app/LaboratoryCategories/SaveLaboratoryIndicators', payload)
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/laboratoryCategories/index.ts